import { environment } from '../../environment';
import { GetCurrentUserDocument } from '../app/queries.generated';
import { useStopImpersonateUserMutation } from './mutations.generated';

type HookArgs = {
  companyId: string;
  employeeId: string;
};

type HookResult = {
  loading: boolean;
  stopEmployeeImpersonation: () => void;
};

export function useStopEmployeeImpersonation({
  employeeId,
  companyId
}: HookArgs): HookResult {
  const [stop, { loading }] = useStopImpersonateUserMutation({
    refetchQueries: [GetCurrentUserDocument],
    onCompleted: () => {
      window.location.href = `${environment.ADMIN_APP_URL}/companies/${companyId}/employees/${employeeId}/details`;
    }
  });

  return {
    loading: loading || !employeeId || !companyId,
    stopEmployeeImpersonation: stop
  };
}
